module.exports = __webpack_public_path__ + "img/531.0799f687.jpg";